import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import '../styles/Investidor.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import axios from "axios";

import { setInvestidor } from "../redux/actions";
import Investidores from "../components/Investidores";
import { formatCnpj } from "../utils/Tools";



export const formatBankAccount = (text) => {
    if (text) {
        const accountNumber = text.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();

        if (accountNumber.length <= 1) {
            return accountNumber;
        }

        const lastCharacter = accountNumber.slice(-1);
        const otherCharacters = accountNumber.slice(0, -1);

        const formattedAccount = otherCharacters.replace(/(.{1,4})(?=(.{3})+(?!.))/g, '$1 ') + '-' + lastCharacter;

        return formattedAccount;
    }
};
export const formatarTelefone = (input) => {
    // Remove todos os caracteres não numéricos do input
    if (input) {
        const numeros = input.replace(/\D/g, '');

        // Aplica a máscara (xx) xxxxx-xxxx enquanto o usuário digita
        let telefoneFormatado = '';
        for (let i = 0; i < numeros.length; i++) {
            if (i === 0) {
                telefoneFormatado = '(';
            } else if (i === 2) {
                telefoneFormatado += ') ';
            } else if (i === 7) {
                telefoneFormatado += '-';
            }
            telefoneFormatado += numeros[i];
        }

        return telefoneFormatado;
    }
};
const Investidor = () => {
    const navigate = useNavigate();
    const data = useSelector((state) => state.dados.dados);
    let razao = data.data?.razaoSocial ?? '';
    let email1 = data.data?.email ?? '';
    const storedData = JSON.parse(localStorage.getItem('notaComercial'));
    const user = JSON.parse(localStorage.getItem('user'));
    const investidor = JSON.parse(localStorage.getItem('investidor'));

    const [available, setAvailable] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [razaoSocial, setRazaoSocial] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [credorNumero, setCredorNumero] = useState('');
    const [credorRua, setCredorRua] = useState('');
    const [credorCidade, setCredorCidade] = useState('');
    const [credorBairro, setCredorBairro] = useState('');
    const [credorEstado, setCredorEstado] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [cep, setCep] = useState('');
    const [dadosBancarios, setDadosBancarios] = useState('');
    const [conta, setConta] = useState('');
    const [agency, setAgency] = useState('');
    const [banks, setBanks] = useState([]);
    const [selectedBank, setSelectedBank] = useState('');
    const [bankNumber, setBankNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [credorComplemento, setCredorComplemento] = useState('');
    const [tipoDeInstituicao, setTipoDeInstituicao] = useState('');
    const [investidores, setInvestidores] = useState(false);
    const [representantes, setRepresentantes] = useState([{ nome: '', email: '' }]);

    const dispatch = useDispatch();

    const toggleInvestidores = () => {
        setInvestidores(!investidores);
    }

    const validateInputs = () => {
        if (!razaoSocial || razaoSocial === "") {
            alert('Por favor, insira uma Razão Social válida.');
            return false;
        }

        if (!cnpj || cnpj.replace(/\D/g, '').length !== 14) {
            alert('Por favor, insira um CNPJ válido.');
            return false;
        }

        if (!cep || cep.replace(/\D/g, '').length !== 8) {
            alert('Por favor, insira um CEP válido.');
            return false;
        }

        if (!credorRua || credorRua.trim() === "") {
            alert('Por favor, insira uma Rua válida.');
            return false;
        }

        if (!credorNumero) {
            alert('Por favor, insira um Número válido.');
            return false;
        }

        if (!credorBairro) {
            alert('Por favor, insira um Bairro válido.');
            return false;
        }

        if (!credorCidade) {
            alert('Por favor, insira uma Cidade válida.');
            return false;
        }

        if (!credorEstado) {
            alert('Por favor, insira um Estado válido.');
            return false;
        }

        if (!representantes || representantes.length === 0) {
            alert('Por favor, insira um Nome de Usuário válido.');
            return false;
        }

        if (!telefone) {
            alert('Por favor, insira um Número de Telefone válido.');
            return false;
        }

        if (!selectedBank) {
            alert('Por favor, selecione um Banco.');
            return false;
        }

        if (!bankNumber) {
            alert('Por favor, insira um Número de Banco válido.');
            return false;
        }

        if (!agency) {
            alert('Por favor, insira uma Agência válida.');
            return false;
        }

        if (!conta) {
            alert('Por favor, insira um Número de Conta válido.');
            return false;
        }

        return true; // Todos os campos estão válidos
    };

    const handleSearch = async () => {

        try {
            setLoading(true);
            const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
            console.log('====================================');
            console.log(response.data, 'response.data');
            console.log('====================================');
            setCredorComplemento(response.data.complemento);
            setCredorCidade(response.data.localidade);
            setCredorBairro(response.data.bairro);
            setCredorEstado(response.data.uf);
            setCredorRua(response.data.logradouro);
        } catch (error) {
            console.error('Error fetching address:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        // Esta função será executada após cada renderização do componente
        // Role a página para o topo
        window.scrollTo(0, 0);
    }, []);

    const keywordsToPrioritize = ['caixa eco', 'itaú uni', 'bco do brasil', 'bradesco s', 'santander', 'original', 'banco inter', 'bdigital'];

    const sortedBanks = [...banks].sort((a, b) => {
        const bankNameA = a.name ? a.name.toLowerCase() : '';
        const bankNameB = b.name ? b.name.toLowerCase() : '';

        const priorityA = getPriority(bankNameA);
        const priorityB = getPriority(bankNameB);

        if (priorityA !== priorityB) {
            return priorityA - priorityB; // Coloque o banco com prioridade maior primeiro
        } else {
            return bankNameA.localeCompare(bankNameB); // Ordem alfabética padrão
        }
    });

    function getPriority(name) {
        for (let i = 0; i < keywordsToPrioritize.length; i++) {
            if (name.includes(keywordsToPrioritize[i])) {
                return i; // Retorna a posição da primeira correspondência encontrada
            }
        }
        return keywordsToPrioritize.length; // Se não houver correspondências, use a prioridade máxima
    }

    useEffect(() => {
        fetch('https://brasilapi.com.br/api/banks/v1')
            .then(response => response.json())
            .then(data => setBanks(data))
            .catch(error => console.error('Ocorreu um erro ao buscar os bancos:', error));
        setDadosBancarios(`Banco: ${selectedBank}-${bankNumber}/Agencia: ${agency}/Conta: ${conta}`);
    }, [available]);

    const handleBankChange = (event) => {
        const selectedBankName = event.target.value;
        setSelectedBank(selectedBankName);
        const selectedBankData = banks.find(bank => bank.name === selectedBankName);

        if (selectedBankData) {
            setBankNumber(selectedBankData.code);
        }
        else if (selectedBankName === 'BNK Digital') {
            setBankNumber(547);
        } else {
            setBankNumber('');
        }
    };

    const handleBankNumberChange = (event) => {
        const bankNumber = event.target.value;
        setBankNumber(bankNumber);

        const selectedBankData = banks.find(bank => bank.code == bankNumber);

        console.log("bankNumber:", bankNumber);
        console.log("selectedBankData:", selectedBankData);
        console.log("bankNumber:", bankNumber);
        console.log("Banks:", banks);


        if (selectedBankData) {
            setSelectedBank(selectedBankData.name);
        } else {
            setSelectedBank(''); // Limpar o campo "Dados Bancários" se o número do banco não corresponder a nenhum banco na lista.
        }
    };


    const handlePdf = async (event) => {
        event.preventDefault();
        validateInputs();
        if (!validateInputs()) {
            return; // Evitar a navegação se as validações não passarem
        }

        let dados = {
            userRef: user.data.email,
            razaoSocial: razaoSocial,
            cnpj: cnpj,
            cep: cep,
            rua: credorRua,
            bairro: credorBairro,
            numero: credorNumero,
            complemento: credorComplemento,
            cidade: credorCidade,
            estado: credorEstado,
            representantes: representantes,
            telefone: telefone,
            banco: selectedBank,
            numeroDoBanco: bankNumber,
            conta: conta,
            agencia: agency,
        };

        try {
            // Fazer uma chamada Axios para a rota de criação do investidor
            console.log(dados);
            console.log(dados.representantes)
            const headers = {
            }
           // const response = await axios.post('https://c2easybe-production.up.railway.app/investidor', dados, headers);
           const response = await axios.post(process.env.REACT_APP_BASE_URL+'/investidor', dados, headers);

            if (response.status === 201) {
                dispatch(setInvestidor(dados));
                localStorage.setItem('investidorPreenchido', true);
                localStorage.setItem('investidor', JSON.stringify(dados));
                window.alert('Investidor Cadastrado!');
                navigate('/Emissor');
            } else {
                window.alert('Erro ao cadastrar investidor!');
            }
        } catch (error) {
            console.error('Erro ao criar investidor:', error);
            // Lida com erros de requisição, se necessário
        }
    };

    const handleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    useEffect(() => {
        handleExpand()

    }, [])

    const addRepresentante = () => {
        setRepresentantes([...representantes, { nome: '', email: '' }]); // Adiciona um novo representante vazio
    };

    const removeRepresentante = (index) => {
        const updatedRepresentantes = [...representantes];
        updatedRepresentantes.splice(index, 1);
        setRepresentantes(updatedRepresentantes);
    };

    const handleRepresentanteChange = (index, field, value) => {
        const updatedRepresentantes = [...representantes];
        updatedRepresentantes[index][field] = value;
        setRepresentantes(updatedRepresentantes);
    };

    return (
        <body className="invesBody">
            <div className='fixed'>
                <Header selected={'investidor'} />
            </div>
            <div className="ahead">
                <h2 className="formH2" style={{ textAlign: "center", marginLeft: '10rem', paddingLeft: 0 }}>
                    Gerenciar Investidores
                </h2>
                <div className="div2">
                    <h3>Bem Vindo, {user.data.razaoSocial}</h3>
                </div>
            </div>
            <main className='investidorDoc2'>
                {!investidores && <div className="divToggle">
                    <div className='buttonToggle1' onClick={toggleInvestidores}>
                        {"Cadastrar novo investidor"}
                    </div>
                </div>}
                {investidores ?
                    <form className="formDoc">
                        <div className="divTitleDoc">
                            <h1 className="h1Doc2">Dados do investidor</h1>
                        </div>
                        <div className={`divInputsDoc`}>
                            <label htmlFor="" className="labelInputsDoc">
                                Razão Social:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Insira a Razão Social"
                                value={razaoSocial}
                                onChange={(e) => { setRazaoSocial(e.target.value) }}
                                maxLength={120} />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                CNPJ:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Apenas Números"
                                value={formatCnpj(cnpj)}
                                onChange={(e) => { setCnpj(e.target.value) }}
                                maxLength={18}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                CEP:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Apenas Números"
                                value={cep}
                                onChange={(e) => { setCep(e.target.value) }}
                                onBlur={handleSearch} />{loading && <p width="10%">Buscando...</p>}
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Rua:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Rua Av."
                                value={credorRua}
                                onChange={(e) => { setCredorRua(e.target.value) }}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Número:
                            </label>
                            <input
                                type="number"
                                placeholder="Apenas Números"
                                className={`inputsDoc`}
                                value={credorNumero}
                                onChange={(e) => { setCredorNumero(e.target.value) }}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Complemento:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Complemento"
                                value={credorComplemento}
                                onChange={(e) => { setCredorComplemento(e.target.value) }}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Bairro:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Bairro"
                                value={credorBairro}
                                onChange={(e) => { setCredorBairro(e.target.value) }}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Cidade:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                placeholder="Cidade"
                                value={credorCidade}
                                onChange={(e) => { setCredorCidade(e.target.value) }}
                            />
                        </div>

                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Estado:
                            </label>
                            <input
                                type="text"
                                placeholder="Estado"
                                className={`inputsDoc`}
                                value={credorEstado}
                                onChange={(e) => { setCredorEstado(e.target.value) }}
                            />
                        </div>
                        <div className="divTitleDoc">
                            <h1 className="h1Doc1">Representantes</h1>
                        </div>
                        {representantes.map((representante, index) => (
                            <div key={index} className="divRepresentantes">
                                <div className="divRep2">
                                    <label htmlFor="" className="labelInputsDoc">
                                        Representante {index + 1}:
                                    </label>
                                    <input
                                        type="text"
                                        className={`inputsRep`}
                                        value={representante.nome}
                                        onChange={(e) => handleRepresentanteChange(index, 'nome', e.target.value)}
                                        maxLength={60}
                                    />
                                </div>
                                <div className="divRep2">
                                    <label htmlFor="" className="labelInputsDoc">
                                        E-mail:
                                    </label>
                                    <input
                                        type="text"
                                        className={`inputsRep`}
                                        value={representante.email}
                                        onChange={(e) => handleRepresentanteChange(index, 'email', e.target.value)}
                                    />
                                </div>
                                {index >= 0 && ( // Impede a remoção do primeiro campo
                                    <button type="button" onClick={() => removeRepresentante(index)} className="buttonRep">-</button>
                                )}
                            </div>
                        ))}
                        <div className="buttonRep1" onClick={addRepresentante}>+ Adicionar Representante</div>

                        <div className="divTitleDoc">
                            <h1 className="h1Doc1">Informações complementares</h1>
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Telefone:
                            </label>
                            <input
                                type="text"
                                className={`inputsDoc`}
                                value={formatarTelefone(telefone)}
                                onChange={(e) => { setTelefone(e.target.value) }}
                                maxLength={15} />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Dados Bancários
                            </label>
                            <select value={selectedBank} onChange={handleBankChange} className="selectDoc">
                                <option value="" className="optionInputsDoc">Selecione um banco</option>
                                <option value="BNK Digital" className="optionInputsDoc">BNK Digital</option>
                                {sortedBanks.map((bank, index) => (
                                    <option key={index} value={bank.name} className="optionInputsDoc">
                                        {bank.name}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">Numero do Banco</label>
                            <input
                                type='number'
                                name="Número do banco"
                                placeholder="Selecione um banco"
                                className={`inputsDoc`}
                                value={bankNumber}
                                onChange={handleBankNumberChange}
                                maxLength={20}
                            />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Agência:
                            </label>
                            <input
                                placeholder="12345"
                                type="text"
                                className={`inputsDoc`}
                                value={agency}
                                onChange={(e) => { setAgency(e.target.value) }}
                                maxLength={8} />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">Conta</label>
                            <input
                                placeholder="123 456-X"
                                type="text"
                                className={`inputsDoc`}
                                value={formatBankAccount(conta)}
                                onChange={(e) => { setConta(e.target.value) }}
                                maxLength={13} />
                        </div>
                        <div className="divInputsDoc">
                            <label htmlFor="" className="labelInputsDoc">
                                Tipo de Instituição:
                            </label>
                            <select
                                className="selectDoc"
                                value={tipoDeInstituicao}
                                onChange={(e) => setTipoDeInstituicao(e.target.value)}
                            >
                                <option value="FIDC">FIDC</option>
                                <option value="Factoring">Factoring</option>
                                <option value="Securitizadora">Securitizadora</option>
                            </select>
                        </div>
                        <button className="buttonDoc" onClick={toggleInvestidores}>
                            Cancelar
                        </button>
                        <button className="buttonDoc" onClick={handlePdf} disabled={loading}>
                            {loading ? 'Salvando...' : 'Salvar Informações'}
                        </button>
                    </form>
                    :
                    <Investidores />
                }
            </main>
        </body>
    )
}

export default Investidor